import { render, staticRenderFns } from "./PushSettingsLink.vue?vue&type=template&id=47eeda10&"
import script from "./PushSettingsLink.vue?vue&type=script&lang=js&"
export * from "./PushSettingsLink.vue?vue&type=script&lang=js&"
import style0 from "./PushSettingsLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports